import { Component, Input, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AddPlanNotesModalComponent } from '../../notes/add-plan-notes-modal/add-plan-notes-modal.component';
import { PayerService } from '../../payer.service';
import moment from 'moment';
import { UpdatePlanNotesModalComponent } from '../../notes/update-plan-notes-modal/update-plan-notes-modal.component';
import { Note } from '../../payer';

@Component({
    selector: 'app-plan-notes',
    templateUrl: './plan-notes.component.html',
    styleUrls: ['./plan-notes.component.scss'],
    standalone: false
})
export class PlanNotesComponent implements OnInit {
  @Input() activePlanId: string;
  @Input() notes: Array<Note>;
  addNotesModal: BsModalRef;
  updateNotesModal: BsModalRef;
  count: number;

  constructor(private payerService: PayerService, private modalService: BsModalService) { }

  ngOnInit() {
    this.notes = this.formatNotes(this.notes);
    this.count = this.notes.length;
  }

  formatNotes(notes: Array<Note>) {
    return notes.map(this.formatNote);
  }

  formatNote(note: Note) {
    note['created_at'] = moment(note['created_at']).format('LL');
    note['updated_at'] = moment(note['updated_at']).format('LL');

    return note;
  }

  openAddNoteModal() {
    this.addNotesModal = this.modalService.show(AddPlanNotesModalComponent, {
      initialState: {
        activePlanId: this.activePlanId
      }
    });
    this.addNotesModal.content.onCreate.subscribe((newNote: Note) => {
      this.notes.unshift(this.formatNote(newNote));
      this.count = this.notes.length;
    });
  }

  openEditNoteModal(note: Note) {
    this.updateNotesModal = this.modalService.show(UpdatePlanNotesModalComponent, {
      initialState: {
        activePlanId: this.activePlanId,
        note: Object.assign({}, note)
      }
    });
    this.updateNotesModal.content.onUpdate.subscribe((updatedNote: Note) => {
      const noteToUpdate = this.notes.find((noteObj) => noteObj.id === updatedNote.id);
      noteToUpdate.content = updatedNote.content;
    });
    this.updateNotesModal.content.onDelete.subscribe((deletedNoteId: number) => {
      const indexToRemove = this.notes.findIndex((noteObj) => noteObj.id === deletedNoteId);
      this.notes.splice(indexToRemove, 1);
      this.count = this.notes.length;
    });
  }

}
